module.exports = __webpack_public_path__ + "img/img-business-asset-sec-10.png";